import { cn } from '@herit-fe/heritage-ui';
import { Card, type CardProps } from './card';

/**
 * Elevated 카드 — heviton `Card` 를 **테두리 없이 부드러운 드롭섀도**로 띄운 변형. 기본 Card 의 `border`·`p-4`
 * 를 제거하고 soft shadow 를 얹어, 내부 패딩은 소비처가 소유한다(콘텐츠가 자체 `p-*` 로 리듬 제어). `title`/`action`
 * 등 Card 계약은 그대로 forward, `className` 으로 추가 오버라이드 가능. (구 인라인 `<Card className="p-0 border-0
 * shadow-[…]">` 의 SSOT — 여러 표면에서 재사용.)
 */
/**
 * Elevated **표면** 클래스 — 테두리 없이 soft 드롭섀도로 띄운 면. `ElevatedCard` 뿐 아니라 카드가 아닌 요소
 * (예: `ScopeSelector` 의 `Button`)도 같은 면을 쓰도록 공개한다 — 그림자 값을 소비처에 하드코딩하면 여기서
 * 톤을 바꿔도 안 따라오기 때문(패딩은 포함하지 않음 — 소비처마다 다름).
 *
 * `shadow-none` 이 함께 있는 건 heritage 프리미티브(Card·Button)가 자체 `box-shadow` 를 들고 있어서 —
 * 그걸 끄고 `drop-shadow`(filter) 한 겹만 남긴다.
 */
export const ELEVATED_SURFACE = 'border-0 shadow-none drop-shadow-[0_2px_3px_rgb(0_0_0_/_0.06)]';

/**
 * Elevated 표면 위 **클릭 가능 행/타일**의 hover — `bg-muted/50` 대체.
 *
 * `--muted` 는 light `gray-100`(카드 흰색보다 어두움) / dark `gray-700`(카드 `gray-800`보다 **밝음**)이라 테마마다
 * 대비 방향과 세기가 달라 hover 가 튄다. 대신 **잉크(`--foreground`) 저알파**를 얹으면 light 는 살짝 어두워지고
 * dark 는 살짝 밝아져 — 두 테마 모두 "표면 위에 옅은 막" 이라는 같은 인상이 된다. 알파 하나로 세기 조절.
 *
 * ⚠️ **dark 변형을 반드시 짝으로 유지할 것.** 한때 `hover:bg-gray-50` 단독이었는데, light 에선 멀쩡해 보이지만
 * dark 에선 근-흰색이 얹혀 카드가 번쩍였다. 지금은 light/dark 를 명시적으로 갈라 각 테마의 표면 대비에 맞춘다
 * (`hover:bg-gray-50` / `dark:hover:bg-gray-700`) — 한쪽만 고치면 반대 테마가 깨진다.
 */
export const ELEVATED_SURFACE_HOVER = 'transition-colors hover:bg-gray-50 dark:hover:bg-gray-700';

export function ElevatedCard({ className, ...props }: CardProps) {
  return <Card className={cn(ELEVATED_SURFACE, 'p-0', className)} {...props} />;
}
